import "../styles/MyProjects.css"
export const MyProjects = () => {
    return(
        <div id="my-projects">
                <div className="card">
                    <div className="card-title display-6">Ticari Stok Takip Sistemi</div>
                    <img src="images/stok.jpg" alt="" className="card-image" />
                    <div className="card-footer"><a target="_blank" href="https://herasystem-9d7d8.web.app/" className="btn btn-primary">İncele</a></div>
                </div>
                <div className="card">
                    <div className="card-title display-6">Öğrenci Takip Sistemi</div>
                    <img src="images/ogrenci.png" alt="" className="card-image" />
                    <div className="card-footer"><a href="https://student-system-63dab.web.app/"  className="btn btn-primary">İncele</a></div>
                </div>
            </div>
    )
}